// extracted by mini-css-extract-plugin
export default {"sortHeader":"SortableBlock_sortHeader__qofll","sorted":"SortableBlock_sorted__O4joD","ascend":"SortableBlock_ascend__nXiMY"};